export const environment = {
  production: true,
  API_ENDPOINT: "https://api.makemeclear.com/v1",
  PDF_GENERATOR_ENDPOINT:
    "https://p7nqrs1ayl.execute-api.eu-west-1.amazonaws.com/dev/pdf",
  DOMAIN_WHITELIST: ["api.makemeclear.com"],
  RECAPTCHA_SITE_KEY: "6LfNI3gUAAAAAG-ICIXWZ1WLMIztHFPr-BfuWXbm",
  RECURLY_PUBLICK_KEY: "ewr1-p2yT9hkdcYFu1a4a4w2hpS",
  DEFAULT_LANG: "en",
  SUPPORTED_LANGUAGES: [
    {
      lang: "pt",
      locale: "pt_PT",
      name: "Português",
    },
    {
      lang: "en",
      locale: "en_US",
      name: "English",
    },
    {
      lang: "de",
      locale: "de_DE",
      name: "Deutsch",
    },
    {
      lang: "es",
      locale: "es_ES",
      name: "Español",
    },
    {
      lang: "fr",
      locale: "fr_FR",
      name: "Français",
    },
    {
      lang: "ru",
      locale: "ru_RU",
      name: "Pусский",
    },
  ],
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts